// @flow

import React from 'react'
import { Subscribe } from 'unstated'
import ShopsBuyerState from '../state'

type Props = {
  childProps: {
    body: React$Element,
  },
}

class ShopsBuyerStateContainer extends React.Component<Props> {
  render() {
    const { childProps } = this.props
    return React.cloneElement(childProps.body, { ...this.props })
  }
}

export default (props: Props) => (
  <Subscribe to={[ShopsBuyerState]}>
    {shopsBuyerState => (
      <ShopsBuyerStateContainer
        shopsBuyerState={shopsBuyerState}
        childProps={props}
      />
    )}
  </Subscribe>
)
